// JsFromRoutes CacheKey 220a2c08f2b65a1b5843f56da6d007f5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  folderTemplates: definePathHelper('post', '/templates/folder_templates'),
}
